export default __webpack_public_path__ + "static/media/hero-video-safari-en.dce65576.mp4";